"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TableRowAction = void 0;

var tslib_1 = require("tslib");

var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");

var ui_tool_tip_1 = require("@hopin-team/ui-tool-tip");

var react_1 = tslib_1.__importDefault(require("react"));

var row_action_1 = require("../styled/row-action");

var TableRowAction = function TableRowAction(_a) {
  var className = _a.className,
      __UIScope = _a.__UIScope,
      title = _a.title,
      rest = tslib_1.__rest(_a, ["className", "__UIScope", "title"]);

  var rootClasses = (0, ui_helper_deep_branding_1.useEscapeClasses)({
    block: 'TableRowAction',
    className: className,
    __UIScope: __UIScope
  }).rootClasses;
  return react_1.default.createElement("li", null, react_1.default.createElement(ui_tool_tip_1.ToolTip, {
    align: "bottom",
    hideTip: !title,
    tip: title,
    "aria-hidden": "true"
  }, react_1.default.createElement(row_action_1.RowAction, tslib_1.__assign({
    className: rootClasses,
    title: title
  }, rest))));
};

exports.TableRowAction = TableRowAction;